// Notions de dossier pilotées par le cabinet (Paramètres › Dossiers).
// Désactivé = masqué partout, les données restent en base.

export type DossierFieldFlags = {
  prescription: boolean;
  legalAid: boolean;
};

export const DEFAULT_DOSSIER_FIELD_FLAGS: DossierFieldFlags = {
  prescription: false,
  legalAid: false,
};

export function parseDossierFieldFlags(
  input: Partial<Record<keyof DossierFieldFlags, unknown>> | null | undefined,
): DossierFieldFlags {
  return {
    prescription: input?.prescription === true,
    legalAid: input?.legalAid === true,
  };
}

/** Retire la prescription d'une liste d'événements quand le cabinet ne la suit pas. */
export function withoutPrescription<T extends { kind: string }>(
  events: T[],
  prescriptionEnabled: boolean,
): T[] {
  return prescriptionEnabled ? events : events.filter((e) => e.kind !== 'prescription');
}
